import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IbanForm from './IbanForm';
import InvalidLink from './InvalidLink';
import './BankApp.css';

export default function BankApp() {
    useEffect(() => {
        document.title = 'Dati bancari / Bank details — CX';
    }, []);

    return (
        <BrowserRouter>
            <main className="bank-app">
                <Routes>
                    <Route path="/:token" element={<IbanForm />} />
                    <Route path="*" element={<InvalidLink reason="Link non valido. Controlla l'email." />} />
                </Routes>
            </main>
        </BrowserRouter>
    );
}
